/**
 * WordPress dependencies
 */
import { registerStore } from '@wordpress/data';
/**
 * Internal dependencies
 */

import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';
import resolvers from './resolvers';
import controls from './controls';
/**
 * Module Constants
 */

var MODULE_KEY = 'core/block-directory';
/**
 * Block editor data store configuration.
 *
 * @see https://github.com/WordPress/gutenberg/blob/master/packages/data/README.md#registerStore
 *
 * @type {Object}
 */

export var storeConfig = {
  reducer: reducer,
  selectors: selectors,
  actions: actions,
  controls: controls,
  resolvers: resolvers
};
var store = registerStore(MODULE_KEY, storeConfig);
export default store;
//# sourceMappingURL=index.js.map